import React from "react";
import { useField, useFormikContext } from "formik";
import PhoneInput from "react-phone-input-2";

import "react-phone-input-2/lib/style.css";
import styles from "./PhoneMaskInput.module.scss";

function PhoneMaskInput({ label, ...props }) {
  const [field, meta] = useField(props);
  const { setFieldValue, setFieldTouched, submitForm } = useFormikContext();

  return (
    <>
      <div
        className={`${styles.container} ${
          meta.touched && meta.error ? `${styles.error}` : ""
        }`}
      >
        <PhoneInput
          // preferredCountries={["tr", "az"]}
          country={"us"}
          {...field}
          inputProps={{ ...props }}
          onChange={(phone, country) => {
            // value, country, e, formattedValue

            setFieldValue(field.name, phone);
            // setFieldValue("userCountryInfo", country);
          }}
          onBlur={() => {
            setFieldTouched(field.name, true);
          }}
          onEnterKeyPress={() => {
            submitForm();
          }}
          countryCodeEditable={false}
        />
      </div>
    </>
  );
}

export default PhoneMaskInput;
